import { render, staticRenderFns } from "./ChecksItem.vue?vue&type=template&id=32c07478"
import script from "./ChecksItem.vue?vue&type=script&lang=js"
export * from "./ChecksItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports